// extracted by mini-css-extract-plugin
export default {"link":"ActionLink_link__5mPR6"};